import send from '../../utils/fetch'
import {nameToSlug} from '../../utils/utils'
import router from "../../router";

const actions = {
    async ADD_PRELANDING({ dispatch }, prelanding) {
        try {
            prelanding.slug = nameToSlug(prelanding.name)
            prelanding.landing_id = prelanding.id
            delete prelanding.offer_id
            delete prelanding.id
            const {data} = await send(global.$url.prelandings.create, 'POST', {data: prelanding})
            dispatch('GET_ALL_PRELANDINGS')
            return data
        } catch (e) {}
    },

    async GET_ALL_PRELANDINGS({ commit, dispatch }) {
        try {
            const { data } = await send(global.$url.prelandings.get, 'GET')
            commit('SET_PRELANDINGS', data.result)
            return data
        } catch (e) {}
    },

    async UPDATE_STATUS_PRELANDING({ dispatch }, {id}) {
        try {
            const {data} = await send(global.$url.prelandings.destroy, 'DELETE', {data: {id}})
            dispatch('GET_ALL_PRELANDINGS')
            return data
        } catch (e) {}
    },

    async EDIT_PRELANDING({ dispatch }, prelanding) {
        try {
            prelanding.slug = nameToSlug(prelanding.name)
            const {data} = await send(global.$url.prelandings.update, 'PUT', {data: prelanding})
            dispatch('GET_ALL_PRELANDINGS')
            return data
        } catch (e) {}
    }
}

export default actions
